import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { GetHotelListRequest, getHotelList, Hotel } from '../api/hotels'

export type HotelListState = {
   isPristine: boolean
   isFetching: boolean
   items: Array<Hotel>
   totalSize: number
}

const initialState: HotelListState = {
   isPristine: true,
   isFetching: false,
   items: [],
   totalSize: 0,
}
export const getHotelListThunk = createAsyncThunk(
   'getHotelList',
   async (request: GetHotelListRequest | undefined, { rejectWithValue }) => {
      try {
         return await getHotelList(request)
      } catch {
         return rejectWithValue(null)
      }
   },
)

export const hotelListSlice = createSlice({
   name: 'hotelListSlice',
   initialState,
   reducers: {
      clear: () => {
         return initialState
      },
   },
   extraReducers(builder) {
      builder.addCase(getHotelListThunk.pending, (state) => {
         state.isPristine = false
         state.isFetching = true
      })
      builder.addCase(getHotelListThunk.fulfilled, (state, action) => {
         const { payload } = action
         state.isPristine = false
         state.isFetching = false
         state.items = payload.items
         state.totalSize = payload.totalSize
      })
      builder.addCase(getHotelListThunk.rejected, (state) => {
         state.isPristine = false
         state.isFetching = false
      })
   },
})

export const { clear } = hotelListSlice.actions

export default hotelListSlice.reducer
